import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Container, List, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

import { useAlerts, useNavigation, useTrainingPlanDrills } from 'hooks';
import TrainingPlanDrillSortableList from 'features/trainingPlan/trainingPlanDrill/TrainingPlanDrillSortableList';
import TrainingPlanDrillItem from 'features/trainingPlan/trainingPlanDrill/TrainingPlanDrillItem';

const TrainingPlanDrillList = ({ handleAddClick }) => {
	const {
		trainingPlanDrills,
		findTrainingPlanDrills,
		destroyTrainingPlanDrill,
		resortTrainingPlanDrills,
		setTrainingPlanDrills
	} = useTrainingPlanDrills({
		id: null
	});

	const { showAlertSuccess } = useAlerts();

	const { handleClick, handleEditClick } = useNavigation({
		url: '/training-plan-drills'
	});

	const handleDeleteClick = async (drill) => {
		await destroyTrainingPlanDrill(drill);
		showAlertSuccess('Training plan drill has been deleted');
		findTrainingPlanDrills();
	};

	const onDragEnd = async (result) => {
		setTrainingPlanDrills(result);
		await resortTrainingPlanDrills(result);
	};

	useEffect(() => {
		findTrainingPlanDrills();
	}, []);

	return (
		<>
			{trainingPlanDrills.length > 0 ? (
				<TrainingPlanDrillSortableList
					id="sort-training-plan-drills"
					list={trainingPlanDrills}
					ListContainer={List}
					onDragEnd={onDragEnd}
					ListItem={({ item }) => (
						<TrainingPlanDrillItem
							key={item.id}
							drill={item}
							handleClick={handleClick}
							handleEditClick={handleEditClick}
							handleDeleteClick={handleDeleteClick}
						/>
					)}
				/>
			) : (
				<Container maxWidth="lg">
					<Box
						display="flex"
						flexDirection="column"
						alignItems="center"
						gap={2}
						sx={{ minHeight: 400, py: 4 }}
					>
						<Typography variant="body1" color="text.secondary">
							No training plan drills
						</Typography>
						<Button
							startIcon={<Add />}
							onClick={handleAddClick}
							variant="contained"
						>
							Add a training plan drill
						</Button>
					</Box>
				</Container>
			)}
		</>
	);
};

export default TrainingPlanDrillList;
